module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.sidebarActiveButton === 'box'
    },
    attrs: {
      "title": _vm.$t('general.labels.themes')
    },
    on: {
      "click": function($event) {
        return _vm.goToBox()
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-pop-up"
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1d38cf14!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/buttons/types/Model.vue
 ** module id = 778
 ** module chunks = 1
 **/